import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3e7dc9ae")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.show)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: `nav-wrapper ${_ctx.isApp ? 'is-app' : ''}`
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (i, k) => {
          return (_openBlock(), _createBlock("div", {
            class: "nav-item",
            key: k,
            onClick: _withModifiers(($event: any) => (_ctx.click(i)), ["stop","prevent"])
          }, [
            _createVNode("img", {
              src: i.type === -1 ? (_ctx.musicOn ? i.img : i.imgClose) : i.img
            }, null, 8, ["src"]),
            _createVNode("span", null, _toDisplayString(i.text), 1)
          ], 8, ["onClick"]))
        }), 128))
      ], 2))
    : _createCommentVNode("", true)
})